import React, { useContext, useEffect } from "react"
import { AppContext } from "../../../../context/createContext"
import { OperationButton, OperationWrapper, Button } from "../ElementsStyles"
import HandleOperation from "../helpers/operations"
interface operations_props {
  stake: string
  handleStake: any
  disabled: any
}
export default function BetOperations({
  stake,
  handleStake,
  disabled,
}: operations_props) {
  const { auth, config, handleNotification } = useContext(AppContext)
  const {
    balance: { currency },
  } = auth
  const { maxbet, minbet, prec } = config

  return (
    <OperationWrapper className="operations">
      <div
        onClick={() =>
          !disabled &&
          HandleOperation(
            stake,
            "2x",
            prec,
            minbet,
            maxbet,
            handleStake,
            handleNotification,
            currency
          )
        }
      >
        <OperationButton disabled={disabled} background="red">
          <Button background="red" disabled={disabled}>
            2x
          </Button>
        </OperationButton>
      </div>
      <div
        onClick={() =>
          !disabled &&
          HandleOperation(
            stake,
            "1/2",
            prec,
            minbet,
            maxbet,
            handleStake,
            handleNotification,
            currency
          )
        }
      >
        <OperationButton disabled={disabled}>
          <Button disabled={disabled}>1/2</Button>
        </OperationButton>
      </div>
    </OperationWrapper>
  )
}
